export default __webpack_public_path__ + "static/media/task.95dfcff3.svg";